import { Shield, Zap, Cpu, HardDrive, Network, Lock, Activity, Bell, Layers, Cloud, KeyRound, Users } from "lucide-react";
import GradientBg from "@/components/common/GradientBg";
import { BRAND } from "@/branding.config";

const GROUPS = [
  {
    title: "Performance",
    items: [
      { icon: Zap,     title: "Sub-1ms broker links",  body: "Cross-connects to LD4, NY4, TY3 & TP2." },
      { icon: Cpu,     title: "Dedicated vCPU cores",  body: "No noisy neighbours on Pro & Elite." },
      { icon: HardDrive,title:"NVMe throughout",       body: "Sustained 3M+ IOPS on Elite tier." },
      { icon: Network, title: "400G backbone",         body: "Private optical between all regions." },
    ],
  },
  {
    title: "Security",
    items: [
      { icon: Shield, title: "1.5 Tbps DDoS",        body: "Always-on scrubbing at every edge." },
      { icon: Lock,   title: "Encryption at rest",   body: "AES-256 per-tenant keys." },
      { icon: KeyRound,title:"MFA + WebAuthn",       body: "Hardware key support in portal." },
      { icon: Users,  title: "Fine-grained RBAC",    body: "Roles, permissions, audit trails." },
    ],
  },
  {
    title: "Operations",
    items: [
      { icon: Activity,title:"Live monitoring",   body: "CPU, RAM, disk, network — 1s resolution." },
      { icon: Bell,   title: "Smart alerting",     body: "Multi-channel notifications." },
      { icon: Layers, title: "Instant snapshots",  body: "Backup, clone or rollback in seconds." },
      { icon: Cloud,  title: "API-first",          body: "Public API + webhooks + Terraform." },
    ],
  },
];

export default function Features() {
  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-7xl px-6 pt-24 pb-16">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Features</div>
        <h1 className="mt-3 text-5xl md:text-6xl font-black tracking-tight max-w-3xl">
          Built for people who <span className="brand-gradient-text">actually run</span> production.
        </h1>
        <p className="mt-4 max-w-xl text-muted-foreground">
          Every layer of {BRAND.app_name} — from hardware selection to portal UX — is engineered by operators, for operators.
        </p>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-24 space-y-16">
        {GROUPS.map((g) => (
          <div key={g.title}>
            <h2 className="text-2xl md:text-3xl font-black tracking-tight mb-8">{g.title}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {g.items.map(({ icon: Icon, title, body }) => (
                <div key={title} className="surface p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-primary/40">
                  <div className="h-10 w-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-primary">
                    <Icon size={18} />
                  </div>
                  <h3 className="mt-5 text-lg font-bold">{title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{body}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
